<template>
  <div class="detail-container">
    <div class="detail-header">
      <div class="detail-header-info-avatar">
        <b-skeleton-wrapper class="d-flex flex-column align-items-center" :loading="isLoading">
          <template #loading>
            <b-skeleton type="avatar" width="64px" height="64px" />
          </template>
          <img :src="getAvatar(currentConversation.photo)" alt="avatar" />
        </b-skeleton-wrapper>
      </div>
      <div class="detail-header-title">
        <b-skeleton-wrapper class="d-flex flex-column align-items-center" :loading="isLoading">
          <template #loading>
            <b-skeleton width="200px" height="20px" />
            <b-skeleton width="170px" height="20px" />
          </template>
          <span class="detail-header-title-text">{{ currentConversation.name.nome }}  <i class="fa fa-info-circle" :title="getOrigemDisplayName(currentConversation)"></i></span>
          <span class="detail-header-title-document" v-if="document">{{ documentType }}: {{ document }}</span>
          <span v-else>Não é cooperado</span>
        </b-skeleton-wrapper>
      </div>

      <b-button v-if="person.id !== null && !isLoading" variant="link" style="color: #006a5b !important;"
        @click="handleOpenPersonDetails">
        Detalhes do Associado <i class="fas fa-user mr-1" />
      </b-button>
    </div>
    <div class="detail-content">
      <div v-for="(detail, index) in details" :key="index" class="detail-content-item">
        <b-skeleton-wrapper class="d-flex flex-column align-items-center" :loading="isLoading">
          <template #loading>
            <b-skeleton width="100%" height="20px" />
            <b-skeleton width="100%" height="20px" />
          </template>
          <span class="detail-content-item-title">{{ detail.label }}</span>
          <span class="detail-content-item-value">{{ detail.value }}</span>
        </b-skeleton-wrapper>
      </div>
      <div v-show="detailsFinalization.length !== 0">
        <a href="javascript:void(0);" @click="toggleAll" class="toggle-all-button">
          <i :class="showAll ? 'fas fa-eye-slash' : 'fas fa-eye'" style="font-size: 16px" v-b-tooltip.hover></i>
          {{ showAll ? 'Esconder Atendimentos' : 'Mostrar Atendimentos' }}
        </a>

          <div v-if="showAll">
            <div v-for="(group, index) in groupedDetailsFinalization" :key="index" class="detail-content-item">
                <div v-for="(final, idx) in group.details" :key="idx" class="detail-content-item-detail">
                  <div class="detail-content-item-detail-container">
                    <span class="detail-content-item-title-final" @click="handleClick(final.conversationId)">{{ final.title }}</span>
                    <span class="detail-content-item-title" @click="handleClick(final.conversationId)">{{ final.label }}</span>
                    <span class="detail-content-item-value" @click="handleClick(final.conversationId)">
                      {{ final.value }}
                    </span>
                  </div>
                </div>
              </div>
            <ChatModal ref="messagesModal" />
          </div>
        </div>
      </div>

    <div class="detailButton">
      <defaultbutton :onClick="openAttachModal" btnVariant="btn-third" icon="fas fa-arrow-right"
        text="transferir" />
      <defaultbutton :onClick="openAttachModalFinaliza" btnVariant="btn-outline-third"
        icon="fas fa-user-slash" text="finalizar" />
    </div>
    <b-modal centered ref="modal-new" v-model="showModalTransfer" title="Transferir">
      <b-tabs>
        <b-tab title="Transferir">
          <label for="username-select">Selecione um usuário:</label>
          <b-form-select id="username-select" v-model="selectedUsername" :options="usernames"></b-form-select>

          <label style="margin-top:10px" for="observation">Observação:</label>
          <toogleswitch style="margin-top: 10px;" v-model="createObservation" label="Adicionar Observação" />

          <div v-show="createObservation">
            <div style="margin-top: 10px;">
              <b-form-textarea id="observation" v-model="observationTranfer" placeholder="Observação" maxlength="45"></b-form-textarea>
            </div>
          </div>
        </b-tab>

        <!-- <b-tab title="Outras Informações">
          <p>Aqui você pode adicionar outras informações relacionadas ao modal.</p>
        </b-tab> -->
      </b-tabs>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="sendUpdateOperator" v-b-tooltip.hover :title="'Transferir'">
            <i class="fa fa-angle-double-right"></i><span class="d-md-down-none"> Transferir</span>
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal centered ref="modal-new" v-model="showModalFinaliza" title="Finalizar">
      <label for="username-select">Selecione o motivo da finalização:</label>
      <b-form-select id="username-select" v-model="selectedTipo" :options="tipos" required></b-form-select>
      <label style="margin-top:10px" for="observation">Observação:</label>
      <toogleswitch style="margin-top: 10px;" v-model="createObservation" label="Adicionar Observação" />
      <div v-show="createObservation">
        <div style="margin-top: 10px;">
          <b-form-textarea id="observation" v-model="observation" placeholder="Observação" maxlength="45"
          ></b-form-textarea>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <!-- v-on:click=" " -->
          <button type="button" class="btn btn-third btn-sm" v-on:click="sendUpdateStatus" v-b-tooltip.hover
            :title="'Finalizar'"><i class="fa fa-angle-double-right"></i><span class="d-md-down-none">
              Finalizar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import _ from 'lodash'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import ChatModal from '@/views/private/atendimento/components/details/components/ChatModal.vue'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'Details',
  components: {
    defaultbutton,
    ChatModal,
    toogleswitch
  },
  mixins: [AccountMixin],
  data () {
    return {
      showModalNewConversation: false,
      newConversationPerson: '',
      newConversationSubject: '',
      newConversationMessage: '',
      usernames: [],
      tipos: [],
      showModalTransfer: false,
      showModalFinaliza: false,
      selectedUsername: null,
      selectedTipo: null,
      observation: '',
      observationTranfer: null,
      createObservation: false,
      showAll: false,
      messages: []
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    person: {
      type: Object,
      required: false,
      default: () => null
    },
    currentConversation: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    details () {
      return [
        {
          label: 'Protocolo da Conversa',
          value: this.getValue(this.currentConversation.protocol)
        },
        {
          label: 'Telefone',
          value: this.formatPhoneNumberb(this.getValue(this.currentConversation.identifier))
        },
        {
          label: 'Num. SisBr',
          value: this.getValue(this.person.numSisbr, '-', this.numSisbr)
        },
        {
          label: 'Dt. Nascimento',
          value: this.getValue(this.person.dataNascimento, '-', this.dateFormat)
        },
        {
          label: 'Dt. Início Relacionamento',
          value: this.getValue(this.person.inicioRelacionamento, '-', this.dateFormat)
        },
        {
          label: 'Gerente Rel.',
          value: this.getValue(this.person.gerenteRelacionamento, '-')
        },
        {
          label: 'Agente Rel.',
          value: this.getValue(this.person.agenteRelacionamento, '-')
        }
      ]
    },
    detailsFinalization () {
      if (!this.currentConversation || !Array.isArray(this.currentConversation.finalizations)) {
        return []
      }
      return this.currentConversation.finalizations.map(finalization => {
        let startDay = this.formatDay(finalization.dateCreated) + ' '
        // let startHour = this.formatTime(finalization.dateCreated)
        let endDay = this.formatDay(finalization.dateFinalization) + ' '
        // let endHour = this.formatTime(finalization.dateFinalization)
        return [
          {title: 'Protocolo:', value: this.getValue(finalization.protocol, '-'), conversationId: finalization.conversationId},
          { label: 'Data de Criação:', value: this.getValue(startDay, '-'), conversationId: finalization.conversationId },
          { label: 'Data de Finalização:', value: this.getValue(endDay, '-'), conversationId: finalization.conversationId }
          // { label: 'Tipo', value: this.getValue(finalization.type, '-'), conversationId: finalization.conversationId }
        ]
      }).flat()
    },
    groupedDetailsFinalization () {
      const groups = []
      const itemsPerGroup = 3

      for (let i = 0; i < this.detailsFinalization.length; i += itemsPerGroup) {
        groups.push({
          title: `Finalização ${Math.floor(i / itemsPerGroup) + 1}`,
          details: this.detailsFinalization.slice(i, i + itemsPerGroup).map(detail => {
            return {
              ...detail,
              className: detail.value === this.currentConversation.protocol ? 'detail-content-item-final' : 'detail-content-item-final'
            }
          })
        })
      }

      return groups
    },

    document () {
      if (_.isNil(this.person.document)) {
        return ''
      }

      return Tools.formatCpfCnpj(this.person.document, this.person.tipoPessoa)
    },
    documentType () {
      return this.person.tipoPessoa === 'PJ' ? 'CNPJ' : 'CPF'
    }
  },
  created () {
    if (this.currentConversation) {
      this.getUsernames()
    }
    this.getTiposFinalizacao()
  },
  watch: {
    currentConversation (newValue) {
      if (newValue) {
        this.getUsernames()
      }
    }
  },

  methods: {
    getValue (value, defaultValue, format) {
      if (!value) return defaultValue
      if (format) {
        return new Date(value).toLocaleDateString()
      }
      return value
    },
    openAttachModal () {
      this.showModalTransfer = true
    },
    getOrigemDisplayName (conversation) {
      let origem = conversation.name.origem
      if (origem === 'Conversa') {
        return 'Esse nome é de uma conversa'
      } else if (origem === 'Campanha') {
        return 'Esse nome é de uma campanha'
      } else if (origem === 'Pessoa') {
        return 'Esse nome é de um associado'
      } else {
        return 'Nome não registrado'
      }
    },
    openAttachModalFinaliza () {
      this.showModalFinaliza = true
    },
    async getUsernames () {
      if (!this.currentConversation) {
        console.error('currentConversation is not available.')
        return
      }

      // Verifica o deptoId da currentConversation
      const modules = this.currentConversation.deptoId === null
        ? 'OPERADOR_ATENDIMENTO_GERAL'
        : 'OPERADOR_ATENDIMENTO'

      var requestConfig = {
        params: {
          modules: modules
        }
      }

      if (this.currentConversation.deptoId !== null) {
        requestConfig.params.paId = this.currentConversation.deptoId
      }

      try {
        const response = await AtendimentoRepository.GetUsenames(requestConfig)
        const { data } = response
        this.usernames = data.usernames.map(username => ({
          text: username.nome,
          value: { username: username.username, nome: username.nome }
        }))
      } catch (error) {
        console.error('Error fetching usernames:', error)
      }
    },
    async getTiposFinalizacao () {
      await AtendimentoRepository.GetTipos()
        .then(response => {
          const { data } = response
          console.log(data)
          this.tipos = data.tipos.map(tipo => ({ text: tipo, value: tipo }))
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })
    },
    dateFormat (value) {
      return this.moment(value).format('DD/MM/YYYY')
    },
    handleOpenPersonDetails () {
      this.$router.push({
        name: 'DetalhesAssociate',
        params: {
          associateId: this.person.id,
          backUrl: 'Atendimento'
        }
      })
    },
    sendUpdateOperator () {
      if (!this.selectedUsername) {
        this.$bvToast.toast('Por favor, preencha todos os campos obrigatórios.', {
          title: 'Campos obrigatórios',
          variant: 'danger',
          solid: true
        })
        return
      }
      const message = {
        conversationId: this.currentConversation.conversationId,
        username: this.selectedUsername.username,
        nameOperator: this.selectedUsername.nome.replace('\t', ''),
        identifier: this.currentConversation.identifier,
        name: this.currentConversation.name,
        provider: this.currentConversation.provider,
        event: 'transferir',
        protocol: this.currentConversation.protocol,
        description: this.observationTranfer
      }
      this.$emit('sendUpdateOperator', message)
    },
    sendUpdateStatus () {
      if (!this.selectedTipo) {
        this.$bvToast.toast('Por favor, preencha todos os campos obrigatórios.', {
          title: 'Campos obrigatórios',
          variant: 'danger',
          solid: true
        })
        return
      }
      const message = {
        conversationId: this.currentConversation.conversationId,
        status: 'F',
        type: this.selectedTipo,
        observation: this.observation,
        nameOperator: this.account.pessoa.nome.replace('\t', ''),
        identifier: this.currentConversation.identifier,
        name: this.currentConversation.name,
        provider: this.currentConversation.provider,
        protocol: this.currentConversation.protocol
      }
      this.$emit('sendUpdateStatus', message)
    },
    formatPhoneNumberb (phoneNumberString) {
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '').replace('55', '')
      let match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return phoneNumberString
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    formatDay (isoString) {
      const date = new Date(isoString)
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    formatTime (isoString) {
      const date = new Date(isoString)
      return `${date.getHours()}h:${date.getMinutes()}m:${date.getSeconds()}s`
    },
    toggleAll () {
      this.showAll = !this.showAll
    },
    handleClick (conversationId) {
      this.$refs.messagesModal.openAttachModalMessages(conversationId)
    }
  }
}
</script>

<style scoped lang="scss">
.detail-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: #fff;
  border-top: 1px solid #cfd8dc;
  border-bottom: 1px solid #cfd8dc;
  border-right: 1px solid #cfd8dc;
  padding: 14px;

  .detail-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: #F1F2F6 solid 1px;

    .detail-header-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0.5rem;

      .detail-header-title-text {
        color: #1F2227 !important;
        font-size: 18px;
      }

      .detail-header-title-document {
        color: #1F2227 !important;
        font-size: 16px;
      }
    }

    .detail-header-info-avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.5rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background-color: #e3e3e3;
      }
    }
  }

  .detail-content {
    display: flex;
    flex-direction: column;
    padding: 0.35rem;
    overflow-y: auto;
    flex: 1 1 0;

    .detail-content-item {
      display: flex;
      flex-direction: column;
      padding: 0.35rem;

      .detail-content-item-title {
        color: #434A54 !important;
        font-weight: 700;
        font-size: 13px;
        margin-right: 5px;
      }
      .detail-content-item-title-final {
        color: #1BACA0 !important;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 700;
        font-size: 13px;
        margin-right: 5px;
      }

      .detail-content-item-value {
        font-size: 13px;
        font-weight: 500;
      }
      .detail-content-item-final {
        font-size: 13px;
        color: #1BACA0;
        cursor: pointer;
        text-decoration: underline;
        transition: color 0.3s ease;

        &:hover {
          color: #006400;
        }
      }
      .detail-content-item-noLink {
        font-size: 13px;
        font-weight: 500;
        color: #1F2227;
      }
    }
  }

  .detailButton {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    max-height: 285px;
  }
  .modal-content {
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/details/Details.vue